/* eslint-disable react/jsx-pascal-case */
import {
    Col, Form, Input, Row, Select, DatePicker, Switch
} from "./../../ui/ot";
import React, { useEffect } from "react";

const TemplateTypeForm = (
    {
        propsForm = null,
        axiosMode = "post",
        formReloadCount = 0,
        onFormFinish = () => { },
        field
    }
) => {
    const [form] = Form.useForm();

    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
            total: (formValues?.comments * formValues?.number) || 0
        }
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues)
        }
        else {
            form.setFieldsValue(newFormValues)
        }

    }

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
    }
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        })

    }
    const onValuesChange = () => {
        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
        setFormValuesOtherThings(formValues)
    }


    useEffect(() => {
        setDataInitialization()
    }, [])

    useEffect(() => {

        let formValues = null
        if (propsForm) {
            formValues = propsForm.getFieldsValue()
        }
        else {
            formValues = form.getFieldsValue()
        }
    }, [formReloadCount])

    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row gutter={[8, 8]}>
                        <Col span={24}>
                            <Form.Item
                                hidden={true}
                                label={"template_type_id"}
                                name={[field?.name, "template_type_id"]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"分類名稱"}
                                name={[field?.name, "name"]}
                            >
                                <Input>
                                </Input>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Col>
        </Row>
    )
}



export default TemplateTypeForm;
